<template>
  <div class="no-connection" :class="{ 'no-connection--disabled': disabled }">
    <transition name="fade">
      <div v-if="!noConnection">
        <img src="@/assets/logo.svg" alt="" /><br />
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
      <div v-else>
        <h1>Brak połączenia!</h1>
        <p>Spróbuj ponownie za chwilę!</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'no-connection',
  data() {
    return {
      loadTime: 5000,
      noConnection: false,
    }
  },
  props: {
    disabled: Boolean,
  },
  sockets: {
    connect_error() {
      this.noConnection = true
    },
    connected() {
      this.noConnection = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

.no-connection {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% + 20px);
  z-index: 10001;
  background-color: $bg;
  padding-top: 20vh;
  transition: 0.3s;
  opacity: 1;
  visibility: visible;

  &--disabled {
    top: -20px;
    opacity: 0;
    visibility: hidden;
  }

  h1 {
    color: firebrick;
  }

  img {
    width: 64px;
  }
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: $primary;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
